export const FETCH_AVAILABLE_EVENTS_START = 'FETCH_AVAILABLE_EVENTS_START';
export const FETCH_AVAILABLE_EVENTS_SUCCESS = 'FETCH_AVAILABLE_EVENTS_SUCCESS';
export const FETCH_AVAILABLE_EVENTS_FAILURE = 'FETCH_AVAILABLE_EVENTS_FAILURE';

export const SET_AVAILABLE_EVENTS_PAGE_SIZE = 'SET_AVAILABLE_EVENTS_PAGE_SIZE';

export const RESET_AVAILABLE_EVENTS = 'RESET_AVAILABLE_EVENTS';